import React from "react";
import axios from "axios";
import { Icon, notification } from 'antd';
import { setup as URI_SETUP } from "../../../../config/api";

class Contracts extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showLoadingUsers : "hide",
            showUsers : "show",
            contracts_num : 1,
            contracts : [],
            contracts_option : ""
        }
    }

    componentWillMount(){
        this.getContracts();
    }
    componentDidMount(){
        this.veryfyNotifications();
    }

    componentDidUpdate(prevProps, prevState){
        if(this.state.contracts != prevState.contracts){
            this.setContractsOption();
        }
    }
    veryfyNotifications(){
        if(this.props.show_user_edited_notification){
            notification.open({
                message: 'NOTIFICATION',
                description: 'Contract information was successfully edited',
              });
            
            this.props.setUserEditedNotification(false);
        }
        if(this.props.show_user_added_notification){
            notification.open({
                message: 'NOTIFICATION',
                description: 'Contract was successfully added',
              });
            
            this.props.setUserAddedNotification(false);
        }
    }
    getContracts(){
        let self = this;
        var qs = require("qs");

        const dataToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token")
        });
        axios.post(URI_SETUP+"getContracts", dataToSent)
            .then(request => { 
                console.log(request.data);
                this.setState({
                    contracts : request.data
                });
            });
    }

    setContractsOption(){
        let self = this;
        var count_contr = Object.keys(self.state.contracts).length;
        var contracts_obj =  Object.keys(self.state.contracts).map((key, index) => {
            return (<tr key={self.state.contracts[key]._id} value={self.state.contracts[key]._id}>
                    <td>{self.state.contracts[key].name}</td>
                    <td>{self.state.contracts[key].subdomain}</td>
                    <td>{self.state.contracts[key].contract[0].brands}</td>
                    <td>{self.state.contracts[key].contract[0].hotels}</td>
                    <td>{self.state.contracts[key].contract[0].users}</td>
                    <td>{self.state.contracts[key].contract[0].extra_users}</td>
                    <td><span className="table-hotels">{self.state.contracts[key].contract[0].module[0]}</span></td>
                    <td>{self.state.contracts[key].contract[0].begin_date}</td>
                    <td>
                        <div className="action-elements">  
                            <a onClick={this.handleEditContract.bind(this,self.state.contracts[key]._id)} ><img className="action-element-icon" src="../../images/iconos/edit.svg" /></a>
                            {/* <img className="action-element-icon" src="../../images/iconos/cerrar.svg"/> */}
                        </div>
                    </td>
                </tr>);
            });

        self.setState({
            contracts_option : contracts_obj,
            contracts_num : count_contr
        });
    }

    handleEditContract(business_id){
        this.props.setEditingBusiness(business_id);
        this.props.activeSection("setup","addcontract","","");
    }

    render() {
        return (
            <section>
                
                <div className="head-content "> 
                    <div className="col-md-8 px-2">     
                        <h1>Configuration</h1>
                        <h2>CONTRACTS</h2>
                    </div>
                    <div className="col-md-4 px-2 users-available">
                      <h3 className="color-blue min"><b>CONTRACTS </b></h3>
                      <Icon className={this.state.showLoadingUsers} type="loading" />
                      <p className={"number-user "+ this.state.showUsers}>{this.state.contracts_num}</p>
                      <a onClick={this.handleEditContract.bind(this,"")}><i className="fa  add-user">+</i></a>
                    </div>
                </div> 
                <div className="box regular col-md-12">
                   <h3 className="title-roles-h3"> <b>ACTIVE BUSINESS</b>
                     <select className="account-select top-form-select select-roles">
                         <option></option>
                     </select>
                    </h3>
                    <table className="table-account-info">
                    <thead>
                        <tr className="tr-account-info">
                            <th>NAME</th>
                            <th>SUBDOMAIN</th>
                            <th>BRANDS</th>
                            <th>HOTELS</th>
                            <th>USERS</th>
                            <th>EXTRA USERS</th>
                            <th>MODULES</th>
                            <th>BEGINING DATE</th>
                            <th>ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.state.contracts_option }   
                    </tbody>        
                    </table>
                </div>
            </section>
        )
    }

}

export default Contracts


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/Contracts.js